export const LOOSE_COMMODITY_SLUG = 'LOOSE_COMMODITY'

export function isLooseCommodityProduct(product) {
  return product?.division_slug === LOOSE_COMMODITY_SLUG
}
